import { z } from "zod";

export const inviteMemberSchema = z.object({
  email: z.string().trim().min(1, "Enter an email").email("Enter a valid email address"),
  role: z.string().min(1, "Select a role"),
  monitoring: z.string(),
});

export type InviteMemberValues = z.infer<typeof inviteMemberSchema>;
